import { z } from 'zod'

export const TikTokUserInfoSchema = z.object({
  displayName: z.string().min(1).optional(),
  username: z.string().min(1).optional(),
  followerCount: z.number().int().nonnegative().optional()
})

export type TikTokUserInfo = z.infer<typeof TikTokUserInfoSchema>
